import { render } from "./MindUpPracticeForm.vue?vue&type=template&id=305b3a85&scoped=true&ts=true"
import script from "./MindUpPracticeForm.vue?vue&type=script&lang=ts"
export * from "./MindUpPracticeForm.vue?vue&type=script&lang=ts"

import "./MindUpPracticeForm.vue?vue&type=style&index=0&id=305b3a85&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305b3a85"]])

export default __exports__